export interface AssessmentScoreSettings {
  show_score_and_percent?: boolean;
  require_passing_score?: boolean;
}

/** Explicit setting wins. Older assessments keep showing the grade only when a minimum is required. */
export function showsScoreAndPercent(settings: AssessmentScoreSettings | null | undefined): boolean {
  if (typeof settings?.show_score_and_percent === 'boolean') {
    return settings.show_score_and_percent;
  }
  return settings?.require_passing_score !== false;
}

export function formatScoreFraction(score: number | null, maxScore: number): string {
  const value = score ?? 0;
  return `${value.toFixed(1)} / ${maxScore.toFixed(1)}`;
}

export function formatScorePercentage(score: number | null, maxScore: number): string {
  if (score === null || maxScore <= 0) return '—';
  const pct = (score / maxScore) * 100;
  return `${pct.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} %`;
}
